import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "test-mode-banner-content items-center flex justify-center w-full" }
const _hoisted_2 = { class: "test-mode-text items-center flex flex-row justify-center w-full" }
const _hoisted_3 = { class: "warning-icon items-center text-primary-green-visited flex" }
const _hoisted_4 = { class: "block text-xs font-semibold leading-none ml-1 uppercase" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "test-mode-banner-buttons items-center flex flex-row justify-end w-1/5" }

import { computed, ref } from 'vue';
import { useGlobalStore } from '@/stores/globalStore';
import { useRenderStore } from '@/builder/stores/renderStore';
import { AppUrls } from "@/constants/AppUrls";
import StandardButton from "@/components/shared/button/standard/Button.vue"
import { inject } from 'vue';
import { AxiosInstance } from 'axios';
import UserContext from '@/interfaces/account/UserContext';
import { ApiUrls } from '@/constants';
import { ModalDisplayType, PartialDisplayType } from '@/builder/enums';


export default /*@__PURE__*/_defineComponent({
  __name: 'TestModeBanner',
  props: {
    source: {
        type: String,
        required: true,
        default: "app"
    }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "531de246": (backgroundColor.value)
}))

const renderStore = useRenderStore();
const globalStore = useGlobalStore();

const axios = inject<AxiosInstance>("axios")!;

const props = __props;

//data
const isLoading = ref(false);

//computed properties
const testModeEnabled = computed(() => {
    if (props.source === 'public') {
        return renderStore.isTestMode;
    }

    return globalStore.userContext?.isTestModeEnabled
});

const currentRoute = computed(() => {
    return globalStore.currentRoute;
});

const isTestDataRoute = computed(() => {

    if (currentRoute.value === null || currentRoute.value === undefined) {
        return false;
    }

    //if url is donor view
    if (currentRoute.value.includes(AppUrls.Donors.List + "/") && !currentRoute.value.includes('edit')) {
        return true;
    }

    //if url is project view
    if (currentRoute.value.includes(AppUrls.Projects.List + "/") && !currentRoute.value.includes('edit')) {
        return true;
    }

    //if url is segment view
    if (currentRoute.value.includes(AppUrls.Segments.List + "/") && !currentRoute.value.includes('edit')) {
        return true;
    }

    return currentRoute.value === "/" ||
        currentRoute.value === AppUrls.Dashboard ||
        currentRoute.value === AppUrls.Donors.List ||
        currentRoute.value === AppUrls.Gifts.List;
});

const testDataText = computed(() => {
    if (props.source === 'public') {
        return 'Test Data';
    }

    if (isTestDataRoute.value) {
        return 'Test Data Enabled';
    }

    return 'Test Data Disabled';
});

const warningText = computed(() => {
    if (props.source === 'public') {
        return 'Any transactions that go through this form will be added as <strong>test data</strong> to your RaiseDonors database.';
    }

    if (isTestDataRoute.value) {
        return 'The View Test Data toggle is on. Only donors and transactions created in Test Mode will be shown.';
    }

    return 'View Test Data is toggled on, but does not apply to this content. Changes you make here will impact your real data.';
});

const backgroundColor = computed(() => {
    if (props.source === 'public') {
        return '#EDF06D';
    }

    if (isTestDataRoute.value) {
        return '#EDF06D';
    }

    return '#F4F5B9';
});

const alertIcon = computed(() => {
    if (props.source === 'public') {
        return 'fa-solid fa-triangle-exclamation';
    }

    return 'ri-alert-line font-normal';
});

const getContainerClasses = computed(() => {
    if (props.source === 'public') {
        if (renderStore.page.partialDisplayType === PartialDisplayType.Modal &&
            renderStore.page.pageDesign.modalDisplay === ModalDisplayType.Lightbox) {
            return {
                'test-mode-banner-container': true,
                'modal-test-mode-banner': true,
            }
        }

        return {
            'test-mode-banner-container': true
        }
    }

    return {
        'test-mode-banner-container': true
    }
});

//methods
const openHowToUseArticle = () => {
    window.open('https://support.raisedonors.com/hc/en-us/articles/26535781932173-What-is-Test-Mode', '_blank');
}

const turnOffTestMode = () => {
    isLoading.value = true;

    axios.post<UserContext>(ApiUrls.Account.TurnOffTestMode)
        .then(response => {
            globalStore.setUserContext(response.data);

            if (isTestDataRoute.value) {
                //reload the page
                location.reload();
            }
        })
        .catch(error => {
            console.log(error);

            //try to get the user context from the server
            globalStore.loadUserContext();
        })
        .finally(() => {
            isLoading.value = false;
        });
}

return (_ctx: any,_cache: any) => {
  return (testModeEnabled.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(getContainerClasses.value)
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "test-mode-banner-top w-full" }, null, -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("i", {
                class: _normalizeClass([alertIcon.value, "text-xl leading-none"])
              }, null, 2),
              _createElementVNode("span", _hoisted_4, _toDisplayString(testDataText.value), 1)
            ]),
            _createElementVNode("p", {
              class: "text-primary-green-visited text-xs mb-0 ml-4",
              innerHTML: warningText.value
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(StandardButton, {
              class: "how-to-use-button font-normal mr-2",
              text: "How to Use",
              color: "neutral",
              size: "small",
              hasTextAndIcon: true,
              leftIcon: "ri-question-line",
              onClick: openHowToUseArticle
            }),
            (__props.source === 'app')
              ? (_openBlock(), _createBlock(StandardButton, {
                  key: 0,
                  class: "turn-off-button font-normal",
                  color: "neutral",
                  size: "small",
                  text: isLoading.value ? 'Turning Off...' : 'Turn Off',
                  processing: isLoading.value,
                  onClick: turnOffTestMode
                }, null, 8, ["text", "processing"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})